module.exports = __webpack_public_path__ + "img/icon_benefit_08_w.ab7aac52.svg";